/**
 * Initial state
 */
const initialState = {
    fetch: {}
};

/**
 * Refresh reducer
 */
export default function (state = initialState, action) {

    let fetch = {};
    const {type,payload} = action;
    switch (type) {

        case 'REFRESH_RESET':
            return initialState;
        case 'REFRESH_FETCH_TRUE':
            if (typeof(payload.key)==="undefined"){
                return {
                    ...state
                }
            }
            fetch = state.fetch;
            fetch[payload.key] = true;
            return {
                ...state,
                fetch:fetch
            }
        case 'REFRESH_FETCH_FALSE':
            if (typeof(payload.key)==="undefined"){
                return {
                    ...state
                }
            }

            fetch = state.fetch;
            fetch[payload.key] = false;
            return {
                ...state,
                fetch:fetch
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/refresh.js